<script setup lang="ts">
const nuxtApp = useNuxtApp()
const toast = useToast()

// Safely access $pwa - it may be undefined on initial load or if PWA module isn't loaded
const $pwa = computed(() => nuxtApp.$pwa)
const { $pendo } = useNuxtApp()

const { user } = useUserSession()

whenever(
  () => $pwa.value && 'needRefresh' in $pwa.value && $pwa.value.needRefresh,
  () => {
    const pwa = $pwa.value
    if (!pwa || !pwa.updateServiceWorker) return

    toast.add({
      title: 'New version available',
      description: 'Please refresh to use the new version',
      color: 'primary',
      progress: false,
      close: false,
      duration: 0,
      actions: [
        {
          label: 'Reload',
          variant: 'subtle',
          icon: 'i-ph-arrow-clockwise',
          onClick: () => {
            pwa.updateServiceWorker?.()
          },
        },
      ],
    })
  },
  {
    immediate: true,
  },
)

watch(
  [user],

  ([currentUser]) => {
    if (!currentUser || !$pendo) {
      return
    }

    const { email, name } = currentUser

    const roles = currentUser['https://auth.rialtic.io/roles']

    // @ts-expect-error - nuxt-pendo types seem to be outdated, this is working as expected
    $pendo.identify({
      visitor: {
        id: email,
        email,
        full_name: name,
        role: roles[0] ?? '',
        roles: roles?.join(', ') ?? '',
      },
      account: {
        id: email.split('@')[1],
        rialtic_app: 'admin',
      },
    })
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <UApp :toaster="{ expand: false }">
    <NuxtLoadingIndicator
      color="repeating-linear-gradient(to right,#6F7CCD 0%,#28B7F0 62%,#35CDDA 100%)"
    />
    <NuxtPwaManifest />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
